import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { Subject, combineLatest } from 'rxjs';

import { filter, map, startWith, takeUntil } from 'rxjs/operators';

import { UsersService } from 'src/app/pages/users/users.service';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.css'],
})
export class BreadCrumbComponent implements OnInit, OnDestroy {
  breadcrumbs: Breadcrumb[] = [];
  private destroy$ = new Subject<void>();

  private businessTransform: Record<string, string> = {
    lubricants: 'Lubricantes',
    nocore: 'No Core',
    fuels: 'Combustibles',
    foreign: 'Externos',
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private usersService: UsersService
  ) {}

  ngOnInit(): void {
    const navigation$ = this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      startWith(null)
    );

    combineLatest([
      navigation$,
      this.usersService.business.pipe(startWith('')),
      this.usersService.inBusinessSelector.pipe(startWith(true)),
    ])
      .pipe(
        map(([_, business, inSelector]) =>
          this.buildBreadcrumbs(business, inSelector)
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((bc) => {
        this.breadcrumbs = bc;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Builder
  private buildBreadcrumbs(
    business: string,
    inSelector: boolean
  ): Breadcrumb[] {
    const breadcrumbs: Breadcrumb[] = [{ label: 'Inicio', url: '/home' }];
    console.log('breadcrumb Selector:', inSelector);
    let route = this.route.root;
    let url = '';
    console.log('breadcrumb busiiness:', business);
    while (route.firstChild) {
      route = route.firstChild;

      if (route.outlet !== 'primary') continue;
      console.log('route snapsheet: ', route.snapshot);
      const segment = route.snapshot?.url?.map((s) => s.path).join('/');

      //ignorar rutas vacias
      if (!segment) continue;

      url += `/${segment}`;

      let label: string | undefined = route.snapshot.data['breadcrumb'];

      if (!label) continue;

      if (label === 'business' && !inSelector) {
        const routeBusiness = route.snapshot.params['business'] ?? business;
        if (routeBusiness) {
          label = this.businessTransform[routeBusiness] ?? routeBusiness;
          console.log('URL business breadcrum', url);
          url = '/home/' + business;
        }
      }

      breadcrumbs.push({ label, url });
    }

    return breadcrumbs;
  }
}

export interface Breadcrumb {
  label: string;
  url: string;
}
